<template>
  <wd-action-sheet
    custom-class="customer-sheet"
    v-model="show"
    @close="close"
    cancel-text="取消"
    title="选择客服"
    @select="onActionSelect"
  >
    <view class="grid grid-cols-3 gap-12">
      <view
        v-for="item in panels"
        :key="item.title"
        class="bg-white rounded-12 p-12 text-center"
        @click="onActionSelect(item)"
      >
        <image :src="item.iconUrl" class="w-48 h-48 rounded-full mx-auto" />
        <view class="text-14 text-#333 mt-8">{{ item.title }}</view>
        <view
          class="text-12 mt-4 rounded-12 py-4 w-fit mx-auto px-15"
          :class="[item.online ? 'text-green-500 bg-green-50' : 'text-gray-500 bg-gray-50']"
        >
          {{ item.online ? '在线' : '离线' }}
        </view>
      </view>
    </view>
  </wd-action-sheet>
</template>

<script lang="ts" setup>
import { useUserStore } from '@/store'
import { ref } from 'vue'
import Service1Icon from '@/static/images/service-1.png'
import Service2Icon from '@/static/images/service-2.png'
import Service3Icon from '@/static/images/service-3.png'
import { addBrowserOpen, addUrlParam, showModal } from '@/utils'
import dayjs from 'dayjs'
import { useAsyncState } from '@vueuse/core'
import { apiDownloadPageConfig } from '@/service'
import qs from 'qs'

const { state: pageConfig, execute } = useAsyncState(
  () => apiDownloadPageConfig().then((res) => res.data),
  {
    customer_service: [],
    app_download: {
      android: '',
      ios: '',
    },
  },
  {
    immediate: false,
  },
)

const show = ref(false)
const logo = location.origin + '/static/images/logo.jpg'
const userStore = useUserStore()

const props = defineProps<{
  visiter_id: string
  visiter_name: string
  avatar: string
}>()
const visiter_id = props.visiter_id || userStore.userInfo?.mobile || ''
const visiter_name = props.visiter_name || userStore.userInfo?.mobile || ''
const avatar = props.avatar || logo || ''

const panels = computed(() => {
  return pageConfig.value.customer_service.map((item, index) => {
    return {
      title: `客服${index + 1}号线`,
      iconUrl: [Service1Icon, Service2Icon, Service3Icon][index % 3],
      subname: '在线',
      value: addUrlParam(
        item.link,
        {
          // 账号: visiter_id,
          // visiter_id,
          // visiter_name,
          // avatar,
        },
        true,
      ),
      online: item.is_online,
    }
  })
})

const close = () => {
  show.value = false
}

const open = async () => {
  uni.showLoading()
  await execute()
  uni.hideLoading()
  show.value = true
}

const onActionSelect = (item: any) => {
  const now = dayjs()
  const startTime = dayjs().set('hour', 9).set('minute', 0).set('second', 0)
  const endTime = dayjs().set('hour', 22).set('minute', 0).set('second', 0)

  if (!item.online) {
    showModal('当前客服线路繁忙，请您更换其他线路客服咨询！')
    return
  }

  if (now.isBefore(startTime) || now.isAfter(endTime)) {
    showModal('客服工作时间为上午09:00-晚上22:00')
    return
  }

  location.href = addBrowserOpen(item.value)
}

defineExpose({
  open,
})
</script>
